import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/postgraduateStudies/postgraduateStudiesData.json";

export default function PostgraduateStudies() {
  useSEO(seoConfig.postgraduateStudies);

  return (
    <section className="contacts postgraduateStudies">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Аспирантура
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        Объявлен конкурс на обучение в рамках договоров об образовании за счет
        средств физических или юридических лиц (приказ №144 от 14.06.2017) по
        направлению подготовки клиническая медицина (31.06.01) - Аспирантура по
        специальности 14.01.10 кожные и венерические болезни.
      </h3>

      <Accordion data={data} />
    </section>
  );
}
